import Vue from 'vue';
import Editor from './editor.vue';
import Loader from './loader.vue';
import Navbar from './navbar.vue';

Vue.component(Editor.name, Editor);
Vue.component(Loader.name, Loader);
Vue.component(Navbar.name, Navbar);
